import { Guid, Nillable } from '@web/utils';

export class PublicBoxComponentGroupCosmetic {
  public constructor(
    private readonly data: {
      amount?: Nillable<number>;
      cosmeticBrandName?: Nillable<string>;
      featureFileAlt?: Nillable<string>;
      featureFileUrl?: Nillable<string>;
      id: Guid;
      name: string;
    },
  ) {}

  public get amount(): Nillable<number> {
    return this.data.amount;
  }

  public get cosmeticBrandName(): Nillable<string> {
    return this.data.cosmeticBrandName;
  }

  public get featureFileAlt(): Nillable<string> {
    return this.data.featureFileAlt;
  }

  public get featureFileUrl(): Nillable<string> {
    return this.data.featureFileUrl;
  }

  public get id(): Guid {
    return this.data.id;
  }

  public get name(): string {
    return this.data.name;
  }
}
